import 'css-chunksrc/client/scenes/timeRecordsListingConfiguration/form/columns/form/styles.scss';export default {
  "input": "_input_1v057_1",
  "listRoot": "_listRoot_1v057_14",
  "list": "_list_1v057_14",
  "item": "_item_1v057_30",
  "icon": "_icon_1v057_43",
  "timeSheetIcon": "_timeSheetIcon_1v057_51",
  "name": "_name_1v057_56"
};